import Modernizr from 'modernizr';

import 'formvalidation/src/js/base';
import 'formvalidation/src/js/helper';
import 'formvalidation/src/js/framework/bootstrap';
import 'formvalidation/src/js/validator/notEmpty';

export default class ValidateMessageboxFolderForm {
  constructor(elem) {
    this.form = elem;

    this.framework = 'bootstrap';
    this.trigger = 'blur';
    this.breakpoint = this._getBreakpoint();
    this.fields = this._getFieldsToValidate();
    this.icons = this._getIcons();

    this.init();
  }

  init() {
    if (this.breakpoint === 'screen-sm') {
      this._validateForm(this._getValidationObject());
    } else {
      const validationObject = this._getValidationObject({
        err: { container: 'tooltip' }
      });

      this._validateFormWithTooltip(validationObject);
    }
  }

  _validateForm(obj) {
    $(this.form)
      .formValidation(obj)
      .on('success.form.fv', e => {
        if (e.target.classList.contains('js-inplace-edit')) {
          e.preventDefault();
          this._processForm(e);
        }
      });
  }

  _validateFormWithTooltip(obj) {
    $(this.form)
      .formValidation(obj)
      .on('err.field.fv', (e, data) => {
        const $input = data.element[0];
        const placement = $input.getAttribute('data-fv-tooltip-placement');
        const $icon = data.element.data('fv.icon');
        const title = $icon.data('bs.tooltip').getTitle();

        $icon.tooltip('destroy');

        data.element.tooltip({
          html: true,

          placement,

          template:
            '<div class="tooltip tooltip--error" role="tooltip"><div class="tooltip-arrow tooltip__arrow--error"></div><div class="tooltip-inner tooltip__inner--error"></div></div>',

          title,

          container: 'body'
        });
      })
      .on('success.field.fv', (e, data) => {
        data.element.tooltip('destroy');
      })
      .on('success.form.fv', e => {
        if (e.target.classList.contains('js-inplace-edit')) {
          e.preventDefault();

          this._processForm(e);
        }
      });
  }

  /* eslint-disable class-methods-use-this */
  _processForm(e) {
    const $form = $(e.target);

    // Generate data object
    const data = {};

    // Collect form data
    $form
      .serialize()
      .split('&')
      .forEach(set => {
        const arr = set.split('=');
        const key = arr[0];
        const val = arr[1];

        data[key] = val;
      });

    // Clean-up form data for renaming
    data.album_name = data.foldername;
    delete data.foldername;

    // Send form data to server
    const request = $.ajax({
      url: $form.attr('action'),

      type: 'POST',

      data
    });

    const $folder = $form.parents('tr[data-folder]');
    const $folderLink = $folder.find('.js-folder-link');
    // console.log('$folderLink from validate');
    // console.log($folderLink);
    const $folderRename = $folder.find('[data-folder-action="rename"]');
    const $folderCancel = $folder.find('[data-folder-action="cancel"]');

    const $formGroup = $form.find('.form-group');
    const $formGroupIcon = $formGroup.find('i.form-control-feedback');
    const $formGroupInput = $form.find('input[name="foldername"]');
    const $formGroupButton = $form.find('[type=submit]');

    request.done(() => {
      // Reset form
      $form[0].reset();
      // Remove the has-success class
      $formGroup.removeClass('has-success');
      // Hide the success icon
      $formGroupIcon.hide();
      // Change input value to new foldername
      $formGroupInput.val(data.album_name);
      // Activate Button
      $formGroupButton.removeClass('disabled');
      $formGroupButton.attr('disabled', false);
      // Hide form
      $form.css('display', 'none');
      // Change folder link to new foldername
      $folderLink.find('a span').text(data.album_name);
      // Show folder link
      $folderLink.css('display', '');
      // Hide cancel link
      $folderCancel.css('display', 'none');
      // Show rename link
      // console.log('SHOW FOLDERRENAME BUTTON');
      $folderRename.css('display', '');
    });

    request.fail(jqXHR => {
      const $domAnchor = $folder.find('td');
      const $errorContainer = document.createElement('div');
      const errorMessage = document.createTextNode(
        `${jqXHR.status}: ${jqXHR.statusText}`
      );

      // Append error message to error container
      $errorContainer.appendChild(errorMessage);
      // Add bootstarp alert styles to error container
      $errorContainer.classList.add('alert', 'alert-danger');

      // Remove the has-success class
      $formGroup.removeClass('has-success');
      // Add the has-error class
      $formGroup.addClass('has-error');
      // Change the success icon with the error icon
      $formGroupIcon.removeClass('fa-check');
      $formGroupIcon.addClass('fa-times');
      // Add the error container to the DOM
      $domAnchor.prepend($errorContainer);
    });
  }

  _getIcons() {
    const icons = {
      valid: 'fa fa-check',

      invalid: 'fa fa-times',

      validating: 'fa fa-refresh'
    };

    return icons;
  }

  _getBreakpoint() {
    let breakpoint;

    if (Modernizr.mq('(min-width: 992px)')) {
      breakpoint = 'screen-lg';
    } else if (Modernizr.mq('(min-width: 768px)')) {
      breakpoint = 'screen-md';
    } else {
      breakpoint = 'screen-sm';
    }

    return breakpoint;
  }
  /* eslint-enable class-methods-use-this */

  _getFieldsToValidate() {
    const fields = {
      foldername: {
        verbose: false,

        validators: {
          notEmpty: {
            message: $(this.form)
              .find('[name=foldername]')
              .attr('data-fv-notempty-message')
          },

          stringLength: {
            max: 18,

            message: $(this.form)
              .find('[name=foldername]')
              .attr('data-fv-stringlength-message')
          }
        }
      }
    };

    return fields;
  }

  _getValidationObject({
    framework = this.framework,
    icon = this.icons,
    fields = this.fields,
    trigger = this.trigger,
    err
  } = {}) {
    const object = {
      framework,
      icon,
      fields,
      trigger,
      err
    };

    return object;
  }
}



// WEBPACK FOOTER //
// ./src/main/javascripts/modules/validate_messagebox_folder_form.js